import { useEffect } from 'react';
import { Header } from '@tanstack/react-table';
import { notInOptions, Option } from '../../utils/options';

export const useAutoClearColumnFilterIfNotInOptions = ({
  header,
  options,
  isEnabled = true,
  fallbackValue = null,
}: {
  header: Header<any, unknown>;
  options: Option[];
  isEnabled?: boolean;
  fallbackValue?: any;
}) => {
  useEffect(() => {
    if (!isEnabled) {
      return;
    }
    const value = header.column.getFilterValue();
    if (value != null && notInOptions(value, options)) {
      header.column.setFilterValue(fallbackValue);
    }
  }, [header, options, isEnabled, fallbackValue]);
};
